import { render } from "./ItemRowEdit.vue?vue&type=template&id=5b3647e2&scoped=true&ts=true"
import script from "./ItemRowEdit.vue?vue&type=script&lang=ts"
export * from "./ItemRowEdit.vue?vue&type=script&lang=ts"

import "./ItemRowEdit.vue?vue&type=style&index=0&id=5b3647e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3647e2"]])

export default __exports__